import { useEffect, useState } from "react";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import ListPayments from "./ListPayments";

const Payments = () =>{
    const token = localStorage.getItem("token");
    const [payments,setPayments] = useState();
    const [loading,setLoading] = useState(true);
    const dispatch = useDispatch();
    
    const getPayments = async () =>{
        setLoading(true);
        try {
            const result = await axios.get(`/dashboard/finance-payments`,{
                headers:{ Authorization: `Bearer ${token}`}
            });
            setLoading(false);
            setPayments(result?.data?.data);
        } catch (error) {
            setLoading(false);
            dispatch(setAppError({msg: error.message}));
        }
    }

    useEffect(()=>{
        getPayments();
    },[]);

    return (
        <>
            <ListPayments 
            payments={payments}
            loading={loading}
            titles={[
                "Sno",
                "Payment Id",
                "Reference No.",
                "Amount",
                "Created By",
                "Category",
                "Date",
                "Action"
            ]}
            />
        </>
    )
}

export default Payments;